import React from "react";
import "../Pricelist/Pricelist.css";
import Price from "../Price/Price";
import { Helmet } from "react-helmet";
const Pricelist = () => {
  return (
    <>
      <Helmet>
        {/* ----------------------------------------------------
      BASIC SEO TAGS
  ---------------------------------------------------- */}
        <title>
          ACE Hanei Price List | Sector 12 Noida Extension | 3.5, 4.5 & 4.5-XL
          BHK Pricing
        </title>
        <meta
          name="description"
          content="Check ACE Hanei Sector 12 price list for 3.5 BHK (2290 sq.ft), 4.5 BHK (3200 sq.ft) and 4.5-XL BHK (4190 sq.ft) luxury apartments in Noida Extension. Mivan construction with premium specifications."
        />
        <meta
          name="keywords"
          content="ACE Hanei price, ACE Hanei price list, ACE Hanei Sector 12 cost, 3.5 BHK price Noida Extension, 4.5 BHK cost Greater Noida West, ACE Hanei pricing, luxury apartment prices Noida Extension, ACE Hanei rates, ACE Hanei booking amount, ACE Group pricing, flat prices Sector 12, ACE Hanei Mivan construction price"
        />
        <link rel="canonical" href="https://acegroupsales.com/pricelist" />
        <meta name="robots" content="index, follow" />
        <meta name="theme-color" content="#ffffff" />

        {/* ----------------------------------------------------
      OPEN GRAPH TAGS
  ---------------------------------------------------- */}
        <meta
          property="og:title"
          content="ACE Hanei Price List - 3.5, 4.5 & 4.5-XL BHK Pricing in Noida Extension"
        />
        <meta
          property="og:description"
          content="View complete price list for ACE Hanei Sector 12 luxury apartments. Check rates for 3.5 BHK (2290 sq.ft), 4.5 BHK (3200 sq.ft) and 4.5-XL BHK (4190 sq.ft) with Mivan construction."
        />
        <meta
          property="og:image"
          content="https://acegroupsales.com/poster.webp"
        />
        <meta property="og:url" content="https://acegroupsales.com/pricelist" />
        <meta property="og:type" content="website" />

        {/* ----------------------------------------------------
      TWITTER META TAGS
  ---------------------------------------------------- */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="ACE Hanei Price List & Rates - Sector 12 Noida Extension"
        />
        <meta
          name="twitter:description"
          content="Complete pricing information for ACE Hanei luxury apartments in Sector 12 Noida Extension. Check 3.5, 4.5 & 4.5-XL BHK prices."
        />
        <meta
          name="twitter:image"
          content="https://acegroupsales.com/poster.webp"
        />

        {/* ----------------------------------------------------
      JSON-LD SCHEMA
  ---------------------------------------------------- */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "WebPage",
              name: "ACE Hanei Price List - Luxury Apartments Pricing",
              url: "https://acegroupsales.com/pricelist",
              description:
                "Complete price list for ACE Hanei Sector 12 luxury apartments in Noida Extension. View pricing for 3.5 BHK (2290 sq.ft), 4.5 BHK (3200 sq.ft) and 4.5-XL BHK (4190 sq.ft) apartments with Mivan construction.",
              primaryImageOfPage: {
                "@type": "ImageObject",
                url: "https://acegroupsales.com/poster.webp",
              },
              breadcrumb: {
                "@type": "BreadcrumbList",
                itemListElement: [
                  {
                    "@type": "ListItem",
                    position: 1,
                    name: "Home",
                    item: "https://acegroupsales.com/",
                  },
                  {
                    "@type": "ListItem",
                    position: 2,
                    name: "Price List",
                    item: "https://acegroupsales.com/pricelist",
                  },
                ],
              },
              mainEntity: {
                "@type": "Table",
                name: "ACE Hanei Sector 12 Price List",
                about:
                  "Pricing information for luxury apartments at ACE Hanei Sector 12 Noida Extension",
                cssSelector: ".price-table",
                columns: [
                  {
                    "@type": "PropertyValue",
                    name: "Types of Unit",
                  },
                  {
                    "@type": "PropertyValue",
                    name: "Area",
                  },
                  {
                    "@type": "PropertyValue",
                    name: "Price List",
                  },
                ],
                rows: [
                  {
                    "@type": "TableRow",
                    position: 1,
                    cells: [
                      {
                        "@type": "TableCell",
                        text: "3.5 BHK (TYPE-1)",
                      },
                      {
                        "@type": "TableCell",
                        text: "Area (2290) SQ.FT. (Mivan Constructions)",
                      },
                      {
                        "@type": "TableCell",
                        text: "Cost - Price on Demand",
                      },
                    ],
                  },
                  {
                    "@type": "TableRow",
                    position: 2,
                    cells: [
                      {
                        "@type": "TableCell",
                        text: "4.5 BHK (TYPE-2)",
                      },
                      {
                        "@type": "TableCell",
                        text: "Area (3200) SQ.FT. (Mivan Constructions)",
                      },
                      {
                        "@type": "TableCell",
                        text: "Cost - Price on Demand",
                      },
                    ],
                  },
                  {
                    "@type": "TableRow",
                    position: 3,
                    cells: [
                      {
                        "@type": "TableCell",
                        text: "4.5-XL BHK (TYPE-3)",
                      },
                      {
                        "@type": "TableCell",
                        text: "Area (4190) SQ.FT. (Mivan Constructions)",
                      },
                      {
                        "@type": "TableCell",
                        text: "Cost - Price on Demand",
                      },
                    ],
                  },
                ],
              },
              about: [
                {
                  "@type": "Product",
                  name: "ACE Hanei 3.5 BHK (TYPE-1) Luxury Apartment",
                  description:
                    "3.5 BHK luxury apartment with 2290 sq.ft area, Mivan construction at ACE Hanei Sector 12",
                  sku: "ACE-HANEI-3.5",
                  offers: {
                    "@type": "Offer",
                    priceSpecification: {
                      "@type": "UnitPriceSpecification",
                      priceCurrency: "INR",
                      description: "Price on Demand",
                    },
                    availability: "https://schema.org/InStock",
                  },
                  additionalProperty: [
                    {
                      "@type": "PropertyValue",
                      name: "Type",
                      value: "3.5 BHK (TYPE-1)",
                    },
                    {
                      "@type": "PropertyValue",
                      name: "Area",
                      value: "2290 SQ.FT.",
                    },
                    {
                      "@type": "PropertyValue",
                      name: "Construction Type",
                      value: "Mivan Constructions",
                    },
                    {
                      "@type": "PropertyValue",
                      name: "Price Status",
                      value: "Price on Demand",
                    },
                  ],
                  image: "https://acegroupsales.com/poster.webp",
                },
                {
                  "@type": "Product",
                  name: "ACE Hanei 4.5 BHK (TYPE-2) Luxury Apartment",
                  description:
                    "4.5 BHK luxury apartment with 3200 sq.ft area, Mivan construction at ACE Hanei Sector 12",
                  sku: "ACE-HANEI-4.5",
                  offers: {
                    "@type": "Offer",
                    priceSpecification: {
                      "@type": "UnitPriceSpecification",
                      priceCurrency: "INR",
                      description: "Price on Demand",
                    },
                    availability: "https://schema.org/InStock",
                  },
                  additionalProperty: [
                    {
                      "@type": "PropertyValue",
                      name: "Type",
                      value: "4.5 BHK (TYPE-2)",
                    },
                    {
                      "@type": "PropertyValue",
                      name: "Area",
                      value: "3200 SQ.FT.",
                    },
                    {
                      "@type": "PropertyValue",
                      name: "Construction Type",
                      value: "Mivan Constructions",
                    },
                    {
                      "@type": "PropertyValue",
                      name: "Price Status",
                      value: "Price on Demand",
                    },
                  ],
                  image: "https://acegroupsales.com/a3.webp",
                },
                {
                  "@type": "Product",
                  name: "ACE Hanei 4.5-XL BHK (TYPE-3) Luxury Apartment",
                  description:
                    "4.5-XL BHK luxury apartment with 4190 sq.ft area, Mivan construction at ACE Hanei Sector 12",
                  sku: "ACE-HANEI-4.5XL",
                  offers: {
                    "@type": "Offer",
                    priceSpecification: {
                      "@type": "UnitPriceSpecification",
                      priceCurrency: "INR",
                      description: "Price on Demand",
                    },
                    availability: "https://schema.org/InStock",
                  },
                  additionalProperty: [
                    {
                      "@type": "PropertyValue",
                      name: "Type",
                      value: "4.5-XL BHK (TYPE-3)",
                    },
                    {
                      "@type": "PropertyValue",
                      name: "Area",
                      value: "4190 SQ.FT.",
                    },
                    {
                      "@type": "PropertyValue",
                      name: "Construction Type",
                      value: "Mivan Constructions",
                    },
                    {
                      "@type": "PropertyValue",
                      name: "Price Status",
                      value: "Price on Demand",
                    },
                  ],
                  image: "https://acegroupsales.com/a1.webp",
                },
              ],
              publisher: {
                "@type": "Organization",
                name: "ACE Group",
                url: "https://acegroupsales.com/",
                logo: "https://acegroupsales.com/1.webp",
                contactPoint: {
                  "@type": "ContactPoint",
                  telephone: "+917303734500",
                  contactType: "Price Inquiry",
                  areaServed: "IN",
                  availableLanguage: ["English", "Hindi"],
                },
              },
              provider: {
                "@type": "RealEstateAgent",
                name: "Authorized Channel Partner - Shishir",
                telephone: "+917303734500",
                identifier: "UP RERA Registration No. UPRERAAGT24002",
                priceRange: "Price on Demand",
                disclaimer:
                  "Prices are subject to change without prior notice, and the availability of properties may vary. Information provided is for informational purposes only.",
              },
              mainEntityOfPage: {
                "@type": "FAQPage",
                mainEntity: [
                  {
                    "@type": "Question",
                    name: "What is the price of ACE Hanei apartments?",
                    acceptedAnswer: {
                      "@type": "Answer",
                      text: "ACE Hanei offers 3.5 BHK (2290 sq.ft), 4.5 BHK (3200 sq.ft), and 4.5-XL BHK (4190 sq.ft) luxury apartments with prices available on demand. Contact +917303734500 for current rates and offers.",
                    },
                  },
                  {
                    "@type": "Question",
                    name: "What construction technology is used in ACE Hanei?",
                    acceptedAnswer: {
                      "@type": "Answer",
                      text: "ACE Hanei uses Mivan construction technology for all apartments, ensuring high-quality, durable, and precision-engineered structures.",
                    },
                  },
                  {
                    "@type": "Question",
                    name: "How can I get the current price list for ACE Hanei?",
                    acceptedAnswer: {
                      "@type": "Answer",
                      text: "You can get the current price list by contacting our sales team at +917303734500 or by visiting our office. Prices are subject to change and offered on demand basis.",
                    },
                  },
                  {
                    "@type": "Question",
                    name: "Are there any special offers available for ACE Hanei?",
                    acceptedAnswer: {
                      "@type": "Answer",
                      text: "Special offers and limited-time discounts may be available. Contact our sales team at +917303734500 for current promotions and booking offers.",
                    },
                  },
                  {
                    "@type": "Question",
                    name: "What is included in the price of ACE Hanei apartments?",
                    acceptedAnswer: {
                      "@type": "Answer",
                      text: "ACE Hanei apartments come with premium specifications including modular kitchen, wardrobes, Italian flooring, air conditioners, and access to all amenities. Exact inclusions can be confirmed with our sales team.",
                    },
                  },
                ],
              },
              significantLink: [
                "https://acegroupsales.com/",
                "https://acegroupsales.com/about",
                "https://acegroupsales.com/layout",
                "https://acegroupsales.com/contactus",
              ],
            }),
          }}
        />
      </Helmet>
      <div className="poster-section">
        <img
          src="price.webp"
          alt="noida-extension-new-launch"
          className="poster-image"
        />
      </div>
      <Price />
    </>
  );
};

export default Pricelist;
